module.exports = __webpack_public_path__ + "static/media/OutliersMCQ3_2.a37a9385.svg";